<template>
  <div>
    <LogoutOnlyBar></LogoutOnlyBar>
    <v-content class="mt-10">
      <v-container style="max-width: 1000px">
        <v-card class="mb-6 pt-2 pb-2" v-if="dealerships.length > 1">
          <v-row justify="space-between">
            <v-col
              cols="auto"
              md="auto"
              lg="auto"
              sm="auto"
              v-for="(dealership, index) in dealerships"
              :key="index"
              class="mx-4"
            >
              <v-card class="pa-2" flat>
                <v-icon
                  class="mr-2"
                  :color="dealership.isComplete ? 'primary' : 'gray'"
                  >{{
                    dealership.isComplete ? "mdi-check-circle" : "mdi-circle"
                  }}</v-icon
                >
                <span v-if="dealership.isComplete">
                  {{ dealership.name }} ({{ dealership.crm_group.name }})
                </span>
                <span v-else style="font-weight: bold">
                  {{ dealership.name }} ({{ dealership.crm_group.name }})
                </span>
              </v-card>
            </v-col>
          </v-row>
        </v-card>

        <v-stepper v-model="stepper" class="pt-2">
          <v-stepper-header style="box-shadow: none">
            <v-stepper-step :complete="stepper > 1" step="1">
              {{ $t("consents.consents.welcome") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stepper > 2" step="2">
              {{ $t("consents.consents.termsAndConditions") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stepper > 3" step="3">
              {{ $t("consents.consents.profile") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stepper > 4" step="4">
              {{ $t("consents.consents.dataSharing") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stepper > 5" step="5">
              {{ $t("consents.consents.privacyPolicy") }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stepper > 6" step="6">
              {{ $t("consents.consents.finish") }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card flat>
                <v-card flat class="mx-auto" width="125">
                  <v-row justify="center">
                    <v-img
                      align="center"
                      justify="center"
                      :transition="false"
                      :src="
                        require(`@/assets/${$store.getters.getLogo.path}/logo.png`)
                      "
                      class="mb-8 mt-10 sentinel-logo--style"
                    />
                  </v-row>
                </v-card>

                <v-card-text>
                  <i18n
                    path="consents.consents.asAUserYouWillBeProcessingPersonalDataFromYourClientsInTheSubsequentlyYourCompanyAndYourTeamMustComplyWithTheGeneralDataProtectionRegulationGDPREnforcedByTheEuropeanUnionPleaseMakeSureYouHaveReadAndUnderstoodOur"
                    tag="span"
                  >
                    <template v-slot:appTitle>
                      <span>{{ getTheme.title }}</span>
                    </template>
                    <template v-slot:privacyPolicy>
                      <a :href="getLinks.privacyPolicy">{{
                        $t("consents.consents.privacyPolicy")
                      }}</a>
                    </template>
                    <template v-slot:termsOfUse>
                      <a :href="getLinks.termsOfUse">{{
                        $t("consents.consents.termsOfUse")
                      }}</a>
                    </template>
                  </i18n>
                </v-card-text>

                <v-card-text>
                  <v-row>
                    <v-checkbox
                      color="primary"
                      class="ml-3 mr-2 mt-4"
                      v-model="authorized"
                    >
                      <template v-slot:label>
                        <span class="body-2">
                          {{
                            $t(
                              "consents.consents.iAcknowledgeIHaveReadThePrivacyPolicyAndTermsOfUseAndWillAbideByTheirTerms"
                            )
                          }}
                        </span>
                      </template>
                    </v-checkbox>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-btn text @click="handleLogout">
                    {{ $t("consents.consents.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    :disabled="!authorized"
                    color="primary"
                    :loading="loadingButton"
                    @click="handleStepper(2, false, true)"
                  >
                    {{ $t("consents.consents.continue") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card flat>
                <v-row justify="center">
                  <v-progress-circular
                    :size="55"
                    :width="4"
                    indeterminate
                    color="primary"
                    class="mt-12"
                    v-if="tacContent.length === 0"
                  ></v-progress-circular>
                </v-row>
                <iframe
                  ref="iframetac"
                  id="tacContent"
                  v-if="true"
                  :src="getLinks.termsAndConditions"
                  height="600px"
                  width="100%"
                  frameborder="0"
                  @load="load"
                />
                <v-card-actions>
                  <v-btn text @click="handleLogout">
                    {{ $t("consents.consents.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on">
                        <v-btn
                          v-bind="attrs"
                          class="ml-2"
                          color="primary"
                          :disabled="!iframeLoaded"
                          @click="handleStepper(3, false, true)"
                        >
                          {{ $t("consents.consents.agree") }}
                        </v-btn>
                      </div>
                    </template>
                    <span>{{ $t("consents.consents.scrollToBottom") }}</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card flat>
                <v-card-title>
                  {{
                    $t("consents.consents.completeYourPartnerProfile")
                  }}</v-card-title
                >
                <v-card-text>
                  {{
                    $t(
                      "consents.consents.thisInformationWillBeVisibleToYourCustomersYouCanUpdateThisInformationAtAnyTimeInYourAccountPage"
                    )
                  }}
                </v-card-text>

                <v-row class="justify-center mx-auto mt-2">
                  <v-card flat max-width="500">
                    <v-form ref="form" v-model="validation" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <v-text-field
                            v-model="dealership.name"
                            :label="$t('consents.consents.companyDisplayName')"
                            required
                            autocomplete="off"
                            :rules="nameRule"
                            :hint="$t('consents.consents.required')"
                            persistent-hint
                            :disabled="readonlyFields('name')"
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <v-text-field
                            v-model="dealership.company_name"
                            :label="$t('consents.consents.companyLegalName')"
                            required
                            autocomplete="off"
                            :rules="companyRule"
                            :hint="$t('consents.consents.required')"
                            persistent-hint
                            :disabled="readonlyFields('company_name')"
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <v-text-field
                            v-model="dealership.address"
                            :label="$t('consents.consents.address')"
                            autocomplete="off"
                            :rules="addressRule"
                            :hint="$t('consents.consents.required')"
                            persistent-hint
                            :disabled="readonlyFields('address')"
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <v-text-field
                            v-model="dealership.city"
                            :label="$t('consents.consents.city')"
                            autocomplete="off"
                            :rules="cityRule"
                            :hint="$t('consents.consents.required')"
                            persistent-hint
                            :disabled="readonlyFields('city')"
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <country-selector
                            :initial-country="dealership.country"
                            @change="dealership.country = $event"
                            :disabled="readonlyFields('country')"
                            :label="$t('consents.consents.country')"
                            :hint="$t('consents.consents.required')"
                            :persistent-hint="true"
                            :rules="countryRule"
                            :no-style="true"
                            :key="updateCountry"
                          >
                          </country-selector>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          v-if="
                            !(
                              dealership.is_partner_supergroup &&
                              dealership.is_internal_partner
                            )
                          "
                        >
                          <v-text-field
                            v-model="dealership.email"
                            :label="
                              $t('consents.consents.emailVisibleToCustomers')
                            "
                            autocomplete="off"
                            :rules="emailRule"
                            :hint="
                              dealership.email !== dealership.initalEmail
                                ? $t(
                                    'consents.consents.thisEmailWillBeInvitedToRegisterTheirOwnAccount'
                                  )
                                : $t('consents.consents.required')
                            "
                            persistent-hint
                            :disabled="readonlyFields('email')"
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <v-text-field
                            v-model="dealership.website"
                            :label="$t('consents.consents.website')"
                            autocomplete="off"
                            :disabled="readonlyFields('website')"
                          />
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <v-text-field
                            v-model="dealership.phone"
                            :label="$t('consents.consents.phone')"
                            autocomplete="off"
                            :disabled="readonlyFields('phone')"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                </v-row>
              </v-card>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  :loading="loadingButton"
                  @click="handleStepper(4, true, true)"
                >
                  {{ $t("consents.consents.continue") }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>

            <v-stepper-content step="5">
              <v-card flat>
                <v-row justify="center">
                  <v-progress-circular
                    :size="55"
                    :width="4"
                    indeterminate
                    color="primary"
                    class="mt-12"
                    v-if="ppContent.length === 0"
                  ></v-progress-circular>
                </v-row>
                <div
                  class="mt-8 mx-2 mb-2"
                  style="overflow-y: scroll; height: 600px"
                  v-html="ppContent"
                  v-on:scroll="onScrollPp"
                  id="ppContent"
                ></div>
                <v-card-actions>
                  <v-btn text @click="handleLogout">
                    {{ $t("consents.consents.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on">
                        <v-btn
                          v-bind="attrs"
                          class="ml-2"
                          color="primary"
                          :disabled="!showPpContentBtn"
                          @click="handleStepper(6, false, true)"
                        >
                          {{ $t("consents.consents.agree") }}
                        </v-btn>
                      </div>
                    </template>
                    <span>{{ $t("consents.consents.scrollToBottom") }}</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card flat>
                <v-card-title>{{
                  $t("consents.consents.dataSharingAndRelatedServices")
                }}</v-card-title>
                <v-card-text
                  >{{
                    $t(
                      "consents.consents.noPersonalDataCanBeCollectedAndProcessedWithoutPriorConsentFromYourCustomersForAnyProcessingOfPersonalDataThereMustBeAClearPurposeAndAnAppropriateLegalBasisEGConsentTheServicesDefinedBelowArePurposesToWhichYourCustomersCanOptInInTheirMobileApp"
                    )
                  }}
                </v-card-text>
                <v-card-text class="font-weight-bold pt-0"
                  >{{
                    $t(
                      "consents.consents.dONOTSELECTAServiceIfYourCompanyDoesntOfferItAndYouDontNeedAccessToData"
                    )
                  }}
                </v-card-text>
                <v-card-text>
                  <partner-services
                    :services.sync="services"
                    consents
                  ></partner-services>
                </v-card-text>

                <v-card-text
                  >{{
                    $t(
                      "consents.consents.aPrivacyPolicyWillBeGeneratedAccordingToTheServicesOfferedWhichCanBeReviewedAndConfirmedInTheNextStep"
                    )
                  }}
                  <b>{{
                    $t(
                      "consents.consents.thisPolicyIsLegallyBindingAndWillBeVisibleToYourCustomers"
                    )
                  }}</b>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="handleStepper(5, false, true)">
                    {{ $t("consents.consents.continue") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="6">
              <v-card flat>
                <v-card-title>{{
                  $t("consents.consents.congratulations")
                }}</v-card-title>
                <v-card-text>
                  {{
                    $t(
                      "consents.consents.nowYouAreReadyToStartManagingBoatsInTheIfYouHaveSelectedAnyServicesWhichRequireDataSharingPleaseKeepInMindThatYourCustomersWillNeedToOptIn",
                      { appTitle: getTheme.title }
                    )
                  }}
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    :loading="loading"
                    @click="handleLastStep"
                  >
                    {{ $t("consents.consents.finish") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-content>
  </div>
</template>
<script>
import { AUTH_LOGOUT } from "@/store/actions/auth";
import {
  USER_ACCEPTED_TOS,
  USER_CRM_REQUEST,
  USER_HIDE_TOS_DIALOG_PARTNER,
} from "@/store/actions/user";
import PartnerServices from "@/components/miscellaneous/PartnerServices.vue";
import api from "@/utils/api";
import { mapGetters } from "vuex";
import CountrySelector from "@/components/selectors/CountrySelector.vue";
import restrictions from "@/utils/restrictions";
import LogoutOnlyBar from "@/components/navigation-bar/LogoutOnlyBar.vue";

export default {
  components: {
    PartnerServices,
    CountrySelector,
    LogoutOnlyBar,
  },
  props: {},
  data() {
    return {
      authorized: false,
      stepper: 1,
      loading: false,
      loadingButton: false,
      // nameRule: [(v) => !!v || "Company display name is required"],
      // companyRule: [(v) => !!v || "Company legal name is required"],
      // countryRule: [(v) => !!v || "Country is required"],
      // emailRule: [(v) => /[^@]+@[^.]+\..*/.test(v) || "E-mail must be valid"],
      // addressRule: [(v) => !!v || "Address is required"],
      // cityRule: [(v) => !!v || "City is required"],
      nameRule: [],
      companyRule: [],
      countryRule: [],
      emailRule: [],
      addressRule: [],
      cityRule: [],
      validation: true,
      services: [],
      dealershipUuid: "",
      dealership: {},
      dealerships: [],
      dealer: {},
      currentDealership: {},
      tacContent: {},
      showTacContentBtn: false,
      ppContent: "",
      showPpContentBtn: false,
      tempStep: null,
      updateCountry: 0,
      iframeLoaded: false,
    };
  },
  created() {
    this.setInitialData();
    this.setDealerships(this.getMe);

    let dealershipIndex = this.dealerships.findIndex((dealership) => {
      return !dealership.isComplete;
    });

    if (dealershipIndex === -1) {
      this.$store.dispatch(USER_CRM_REQUEST).then((resp) => {
        this.$store.commit(USER_HIDE_TOS_DIALOG_PARTNER);
        const nextRoute = restrictions.nextBaseRoute(resp);
        this.$router.push(nextRoute);
      });

      return;
    }

    this.currentDealership = this.dealerships[dealershipIndex];
    this.stepper = this.getStep(this.currentDealership, this.getMe);

    this.loadDealership();

    api.getPartnerPp(this.currentDealership.uuid).then((resp) => {
      this.ppContent = resp.data;
    });
  },

  mounted() {},
  computed: {
    ...mapGetters(["getMe", "getLinks", "getTheme"]),
  },
  methods: {
    load() {
      this.iframeLoaded = true;
    },
    setInitialData() {
      //TODO REPLACE strings below
      // nameRule: [(v) => !!v || "Company display name is required"],
      // companyRule: [(v) => !!v || "Company legal name is required"],
      // countryRule: [(v) => !!v || "Country is required"],
      // emailRule: [(v) => /[^@]+@[^.]+\..*/.test(v) || "E-mail must be valid"],
      // addressRule: [(v) => !!v || "Address is required"],
      // cityRule: [(v) => !!v || "City is required"],
      this.nameRule = [
        (v) => !!v || this.$t("consents.consents.nameIsRequired"),
      ];
      this.companyRule = [
        (v) => !!v || this.$t("consents.consents.companyNameIsRequired"),
      ];
      this.countryRule = [
        (v) => !!v || this.$t("consents.consents.countryIsRequired"),
      ];
      this.emailRule = [
        (v) =>
          /[^@]+@[^.]+\..*/.test(v) ||
          this.$t("consents.consents.eMailMustBeValid"),
      ];
      this.addressRule = [
        (v) => !!v || this.$t("consents.consents.addressIsRequired"),
      ];
      this.cityRule = [
        (v) => !!v || this.$t("consents.consents.cityIsRequired"),
      ];
      this.termsAndConditionsDialog = {
        active: false,
        text: this.$t(
          "consents.consents.aPersonAcceptingTheTermsAndConditionsHasToBeProperlyAuthorisedAndEmpoweredToEnterIntoAnAgreementWithBrandDoNotProceedIfYouDonTHaveSuchAuthority",
          { brand: this.getTheme.title }
        ),
        title: this.$t("consents.consents.warning"),
      };
    },
    readonlyFields(input) {
      if (typeof this.dealership.readonly_fields === "undefined") return false;

      return !!this.dealership.readonly_fields.find(
        (element) => element === input
      );
    },

    onScrollPp(event) {
      let ppContent = document.getElementById("ppContent");

      if (
        ppContent.scrollTop >=
        ppContent.scrollHeight - ppContent.clientHeight - 100
      ) {
        this.showPpContentBtn = true;
      }
    },

    onScrollTac(event) {
      let tacContent = document.getElementById("tacContent");

      if (
        tacContent.scrollTop >=
        tacContent.scrollHeight - tacContent.clientHeight - 100
      ) {
        this.showTacContentBtn = true;
      }
    },
    setDealerships(getMe) {
      let dealerships = getMe.dealerships.filter(
        (dealership) => dealership.has_onboarding_feature
      );
      this.dealerships = dealerships.map((dealership) => {
        return {
          ...dealership,
          isComplete: this.isDealershipComplete(dealership),
        };
      });
    },
    isDealershipComplete(dealership) {
      return (
        dealership.is_profile_complete &&
        dealership.pp_template_accept_date !== null &&
        dealership.tac_accept_date !== null
      );
    },
    getStep(dealership, getMe) {
      if (getMe.user.profile.TOS_accept_date === null) {
        return 1;
      } else if (dealership.tac_accept_date === null) {
        return 1;
      } else if (!dealership.is_profile_complete) {
        return 3;
      } else if (dealership.pp_template_accept_date === null) {
        this.checkForBrandConsents(false, 4);
      }
    },

    handleStepper(next, validation = false, save = false) {
      if (validation && !this.$refs.form.validate()) {
        return;
      }

      if (
        validation &&
        this.$refs.form.validate() &&
        save &&
        this.stepper == 3
      ) {
        if (this.dealership.initalEmail !== this.dealership.email) {
          api.inviteDealerUser(
            this.dealership.uuid,
            {
              email: this.dealership.email,
            },
            false
          );
        }
        api.updateDealer(this.dealership.uuid, this.dealership).then((resp) => {
          this.loadingButton = true;
          this.checkForBrandConsents(false, next);
          return;
        });
      }

      if (this.stepper == 4) {
        let data = this.services
          .filter((service) => service.enabled)
          .map((service) => service.uuid);
        let post = { enabled_services: data };
        this.checkForBrandConsents(true, next, post);
        api.getPartnerPp(this.currentDealership.uuid).then((resp) => {
          this.ppContent = resp.data;
          this.stepper = next;
          return;
        });
      }

      if (save && this.stepper == 2) {
        this.loadingButton = true;
        api
          .setTermsAndConditionsForPartners(this.currentDealership.uuid)
          .then((resp) => {
            if (this.getMe.user.profile.TOS_accept_date === null) {
              api.acceptTOS().then((resp) => {
                this.stepper = next;
                this.loadingButton = false;
              });
            } else {
              this.stepper = next;
              this.loadingButton = false;
            }
          });
      }

      if (save && this.stepper == 5) {
        api
          .setPrivacyPolicyForPartners(this.currentDealership.uuid)
          .then((resp) => {
            this.stepper = next;
            this.checkForBrandConsents();
            return;
          });
      }

      if (save && this.stepper == 1) {
        if (this.getMe.user.profile.TOS_accept_date === null) {
          this.$store.dispatch(USER_ACCEPTED_TOS).then((resp) => {
            this.stepper = next;
            return;
          });
        } else {
          this.stepper = next;
          return;
        }
      }

      // this.stepper = next;
      //snackbar.error()
    },
    handleLogout() {
      this.$store
        .dispatch(AUTH_LOGOUT)
        .then(() => this.$router.push({ path: "/login" }));
    },
    handleLastStep() {
      this.$store.dispatch(USER_CRM_REQUEST).then((resp) => {
        this.setDealerships(resp);

        let dealershipIndex = this.dealerships.findIndex((dealership) => {
          return !dealership.isComplete;
        });

        if (dealershipIndex === -1) {
          const nextRoute = restrictions.nextBaseRoute(this.getMe);
          this.$router.push(nextRoute);
          return;
          // this.$router.push({ name: "base" });
          // return;
        }

        this.currentDealership = this.dealerships[dealershipIndex];
        this.stepper = this.getStep(this.currentDealership, resp);

        // this.loadPartnerServices();
        this.loadDealership();
      });
    },

    setPartnerServices(next, post) {
      api.setPartnerServices(this.currentDealership.uuid, post).then((resp) => {
        this.services = [];
        resp.data.forEach((element) => {
          element.learnMore = false;
          this.$set(this.services, this.services.length, element);
        });
        this.loadingButton = false;
      });
    },

    setBrandServices(uuid, next, post) {
      api.setBrandServices(uuid, post).then((resp) => {
        this.services = [];
        resp.data.forEach((element) => {
          element.learnMore = false;
          this.$set(this.services, this.services.length, element);
        });
        this.loadingButton = false;
      });
    },

    loadDealership() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        let promises = [
          api.getDealer(this.currentDealership.uuid),
          api.getDealerList(),
        ];
        Promise.all(promises).then((values) => {
          this.dealership = values[0].data;
          this.dealership.initalEmail = this.dealership.email;
          this.canUserDelete = values[1].data.results.length > 1;
          this.loading = false;
          this.updateCountry++;
          resolve();
        });
      });
    },

    checkForBrandConsents(save = false, next, post) {
      api.getDealer(this.currentDealership.uuid).then((resp) => {
        if (!save) {
          if (
            resp.data.is_internal_partner &&
            resp.data.partner_group.is_supergroup
          ) {
            this.loadBrandServices(resp.data.partner_group.uuid).then(
              (value) => {
                this.stepper = next;
              }
            );
          } else {
            this.loadPartnerServices(next).then((value) => {
              this.stepper = next;
            });
          }
        } else {
          if (
            resp.data.is_internal_partner &&
            resp.data.partner_group.is_supergroup
          ) {
            this.setBrandServices(resp.data.partner_group.uuid, next, post);
          } else {
            this.setPartnerServices(next, post);
          }
        }
      });
    },

    loadPartnerServices() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.services = [];
        api.getPartnerServices(this.currentDealership.uuid).then((resp) => {
          resp.data.forEach((element) => {
            element.active = element.enabled !== null;

            if (element.is_checked === true) {
              element.enabled = true;
            }
            if (element.is_read_only === true) {
              element.disabled = true;
            }
            element.learnMore = false;
            this.services.push(element);
          });
          this.loading = false;
          this.loadingButton = false;
          resolve();
        });
      });
    },

    loadBrandServices(uuid) {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.services = [];
        api.getBrandServices(uuid).then((resp) => {
          resp.data.forEach((element) => {
            element.active = element.enabled !== null;

            if (element.is_checked === true) {
              element.enabled = true;
            }
            if (element.is_read_only === true) {
              element.disabled = true;
            }
            element.learnMore = false;
            this.services.push(element);
          });
          this.loading = false;
          this.loadingButton = false;
          resolve();
        });
      });
    },

    handleSkip() {
      this.$router.push({
        name: "dealers",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
.responsive--iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.container--iframe {
  position: relative;
  width: 100%;
  padding-top: 50%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}
.link--color {
  color: --primary;
}
</style>
